import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'
import { placeParams } from '../ContextApi/cityContext';

// cityId - עמוד הבית של העיר (ממוזג עם הכללי בשרת); placeParams - הרשימות לפי העיר של הלקוח
const getHomePage = async (cityId) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "homeP", { ...placeParams(), ...(cityId ? { cityId } : {}) });
    return (dFromF);
}



export default {
    getHomePage
};